var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "home-container mx-auto min-h-screen",
      on: { click: _vm.handleClickOverlay },
    },
    [
      _c("HomeHeader", {
        ref: "homeHeader",
        attrs: { activeTab: _vm.activeTab, scrollProgress: _vm.scrollProgress },
        on: { "change-tabs": _vm.handleChangeTabs, search: _vm.handleSearch },
      }),
      _c("div", { staticClass: "md:mx-4 px-4 bg-white" }, [
        _vm.activeTab !== 2
          ? _c(
              "div",
              { staticClass: "py-2" },
              _vm._l(_vm.properties, function (item, index) {
                return _c(
                  "div",
                  { key: item.id },
                  [
                    _c("ScrollGrid", {
                      attrs: {
                        index: index,
                        isZh: _vm.isZh,
                        classifyItem: item,
                        items: item.spuList,
                      },
                      on: { updateFavorite: _vm.handleUpdateFavorite },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm.activeTab === 2
          ? _c(
              "div",
              {
                staticClass:
                  "promotional-features py-3 bg-white mt-3 rounded-lg",
              },
              _vm._l(_vm.promotionalFeatures, function (feature) {
                return _c(
                  "div",
                  { key: feature.id, staticClass: "flex items-center pr-2" },
                  [
                    _c("img", {
                      staticClass: "w-12 h-12 mr-2",
                      attrs: { src: feature.src },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 text-gray-800 text-base font-medium leading-relaxed",
                      },
                      [_vm._v(_vm._s(_vm.$t(`home.features.${feature.key}`)))]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _c("TipDialog", {
        attrs: { visible: _vm.tipDialogVisible, type: _vm.tipDialogType },
        on: {
          "update:visible": function ($event) {
            _vm.tipDialogVisible = $event
          },
          "button-click": _vm.handleTipAction,
          close: _vm.handleTipClose,
        },
      }),
      _vm.configFootInfo
        ? _c("div", { staticClass: "md:mx-4 p-4 bg-[#f7f7f7] text-[14px]" }, [
            _c("div", { staticClass: "text-[15px] font-bold" }, [
              _vm._v(_vm._s(_vm.$t("foot.about"))),
            ]),
            _c("div", { staticClass: "text-[15px]" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isZh
                      ? _vm.configFootInfo.about &&
                          _vm.configFootInfo.about.content
                      : _vm.configFootInfo.aboutEn &&
                          _vm.configFootInfo.aboutEn.content
                  ) +
                  " "
              ),
            ]),
            _c("div", { staticClass: "text-[15px] font-bold mt-2 mb-1 mt-5" }, [
              _vm._v(_vm._s(_vm.$t("foot.contact"))),
            ]),
            _c("div", { staticClass: "flex items-center" }, [
              _c("img", {
                staticClass: "w-5 h-5 mr-2",
                attrs: {
                  src:
                    _vm.imageBaseUrl +
                    (_vm.configFootInfo.concatEmail &&
                      _vm.configFootInfo.concatEmail.icon),
                  alt: "",
                },
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.configFootInfo.concatEmail &&
                      _vm.configFootInfo.concatEmail.content
                  )
                ),
              ]),
            ]),
            _vm.configFootInfo.concatPhone &&
            _vm.configFootInfo.concatPhone.content
              ? _c("div", { staticClass: "flex items-center" }, [
                  _c("img", {
                    staticClass: "w-5 h-5 mr-2",
                    attrs: {
                      src:
                        _vm.imageBaseUrl + _vm.configFootInfo.concatPhone &&
                        _vm.configFootInfo.concatPhone.icon,
                      alt: "",
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.configFootInfo.concatPhone &&
                          _vm.configFootInfo.concatPhone.content
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.isZh &&
            _vm.configFootInfo.address &&
            _vm.configFootInfo.address.content
              ? _c("div", { staticClass: "flex items-center" }, [
                  _c("img", {
                    staticClass: "w-5 h-5 mr-2",
                    attrs: {
                      src:
                        _vm.imageBaseUrl + _vm.configFootInfo.address &&
                        _vm.configFootInfo.address.icon,
                      alt: "地址",
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.configFootInfo.address &&
                          _vm.configFootInfo.address.content
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            !_vm.isZh &&
            _vm.configFootInfo.addressEn &&
            _vm.configFootInfo.addressEn.content
              ? _c("div", { staticClass: "flex items-center" }, [
                  _c("img", {
                    staticClass: "w-5 h-5 mr-2",
                    attrs: {
                      src:
                        _vm.imageBaseUrl + _vm.configFootInfo.addressEn &&
                        _vm.configFootInfo.addressEn.icon,
                      alt: "地址",
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.configFootInfo.addressEn &&
                          _vm.configFootInfo.addressEn.content
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "text-[15px] font-bold mt-2 mb-1 mt-7" }, [
              _vm._v(_vm._s(_vm.$t("foot.follow"))),
            ]),
            _c(
              "div",
              { staticClass: "flex items-center" },
              _vm._l(_vm.configFootInfo.followList, function (item, index) {
                return _c("img", {
                  key: index,
                  staticClass: "w-5 h-5 mr-2",
                  attrs: { src: _vm.imageBaseUrl + item.icon },
                  on: {
                    click: function ($event) {
                      return _vm.handleFollow(item)
                    },
                  },
                })
              }),
              0
            ),
            _c("div", { staticClass: "text-[15px] font-bold mt-2 mb-1 mt-7" }, [
              _vm._v(_vm._s(_vm.$t("foot.payment"))),
            ]),
            _c(
              "div",
              { staticClass: "flex items-center flex-wrap gap-y-2" },
              _vm._l(_vm.configFootInfo.payList, function (item, index) {
                return _c("img", {
                  key: index,
                  staticClass: "w-auto h-5 mr-3",
                  attrs: { src: _vm.imageBaseUrl + item.icon },
                })
              }),
              0
            ),
            _c(
              "div",
              {
                staticClass:
                  "text-[14px] mt-7 mb-1 text-[#ff7a00] flex justify-center flex-wrap gap-y-2",
              },
              _vm._l(_vm.configFootInfo.articleList, function (item, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticClass: "cursor-pointer",
                    on: {
                      click: function ($event) {
                        return _vm.handleArticle(item)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.isZh ? item.title : item.titleEn) + " "
                    ),
                    index < _vm.configFootInfo.articleList.length - 1
                      ? _c("span", { staticClass: "mx-2" }, [_vm._v("|")])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _c("div", { staticClass: "w-full text-center my-5" }, [
              _c("div", [
                _vm._v(
                  "©" +
                    _vm._s(_vm.configFootInfo.year) +
                    " " +
                    _vm._s(
                      _vm.isZh
                        ? "yoyotravel 版权所有"
                        : "yoyotravel All Rights Reserved"
                    )
                ),
              ]),
              _c("div", { staticClass: "text-[13px] text-gray-400" }, [
                _vm._v(_vm._s(_vm.configFootInfo.copyrightNo.content)),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("div", {
        staticClass: "safe-area bg-[#f7f7f7]",
        class: { "translate-y-full": !_vm.showTabbar },
      }),
      _c(
        "van-tabbar",
        {
          class: [
            "z-999 transition-transform duration-300 flex md:hidden",
            { "translate-y-full": !_vm.showTabbar },
          ],
          attrs: { route: "" },
        },
        _vm._l(_vm.tabbarItems, function (item) {
          return _c("van-tabbar-item", {
            key: item.name,
            attrs: { to: item.to },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "w-14 h-14",
                        attrs: { src: item.icon },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }